import crownBronze from "assets/images/crownBronze.svg"
import crownGold from "assets/images/crownGold.svg"
import crownSilver from "assets/images/crownSilver.svg"
import type { PropsWithChildren } from "react"
import { ProductModal } from "../ProductModal"
import s from "./ProductModalLeaderboard.module.scss"

export const ProductModalLeaderboard = ({ children }: PropsWithChildren) => (
  <ProductModal.Side>
    <div className={s.modal}>{children}</div>
  </ProductModal.Side>
)

const Podium = ({ children }: PropsWithChildren) => (
  <ul className={s.modal__podium}>{children}</ul>
)

type PodiumItemProps = {
  rank: number
  image: string
  name: string
  score: string
}
const PodiumItem = ({ rank, image, name, score }: PodiumItemProps) => (
  <li className={s.podiumItem}>
    <img className={s.podiumItem__crown} src={getCrownIcon(rank)} alt="" />
    <div className={s.podiumItem__imageWrapper}>
      <img className={s.podiumItem__image} src={image} alt="" />
      <div className={s.podiumItem__rank}>{rank}.</div>
    </div>
    <div className={s.podiumItem__name}>{name}</div>
    <div className={s.podiumItem__score}>{score}</div>
  </li>
)

const Entries = ({ children }: PropsWithChildren) => (
  <ul className={s.modal__entries} tabIndex={0}>
    {children}
  </ul>
)

const MyEntry = ({ children }: PropsWithChildren) => (
  <ul className={s.modal__myEntry}>{children}</ul>
)

type EntryProps = {
  rank: number
  image: string
  name: string
  score: string
}
const Entry = ({ rank, image, name, score }: EntryProps) => (
  <li className={s.entry}>
    <div className={s.entry__rank}>{rank}</div>
    <img className={s.entry__image} src={image} alt="" />
    <div className={s.entry__name}>{name}</div>
    <div className={s.entry__score}>{score}</div>
  </li>
)

const Skeleton = () => (
  <ProductModal.Side>
    <div className={s.skeleton} />
  </ProductModal.Side>
)

ProductModalLeaderboard.Podium = Podium
ProductModalLeaderboard.PodiumItem = PodiumItem
ProductModalLeaderboard.Entries = Entries
ProductModalLeaderboard.MyEntry = MyEntry
ProductModalLeaderboard.Entry = Entry
ProductModalLeaderboard.Skeleton = Skeleton

const getCrownIcon = (rank: number) => {
  if (rank === 1) return crownGold
  if (rank === 2) return crownSilver
  if (rank === 3) return crownBronze
}
